import { ThemeUICSSObject, responsive } from '@apia/theme';
/* IMPORT HERE */

const logo: ThemeUICSSObject = {
  /* PREPEND HERE */
  position: 'fixed',
  right: 0,
  bottom: '50vh',
  left: 0,
  top: 0,
  background: 'ihnerit',
  p: 8,

  img: {
    height: responsive({ 0: 'auto', 3: '14vh' }),
    width: responsive({ 0: '40vw', 3: 'auto' }),
  },
};

export default logo;
